import { getViewApplicationFlags } from '@gonfalon/openapi/operations/getViewApplicationFlags';

import { createQueryOptions } from '../internal/createQueryOptions';

// Split out so views.ts can invalidate this query without a cycle through viewApplications.ts.
export const getViewApplicationFlagsQuery = createQueryOptions(getViewApplicationFlags);
